export const categories = [
  {
    id: 'entertainment',
    name: '娱乐深扒',
    desc: '不聊八卦本身，只拆解娱乐工业的运作方式与内容生产逻辑。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20amber%20theatre%20stage%20curtain%20abstract%20editorial%20photography%20with%20deep%20green%20accents%20and%20moody%20lighting%2C%20high%20detail%20minimal%20composition&width=800&height=600&seq=bl-cat-ent&orientation=landscape',
    count: 312,
  },
  {
    id: 'industry',
    name: '行业起底',
    desc: '从商业模式、成本结构与竞争格局入手，看清一个行业真实的运转规则。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20amber%20industrial%20blueprint%20and%20ledger%20on%20cream%20desk%20abstract%20editorial%20photography%2C%20moody%20lighting%2C%20high%20detail&width=800&height=600&seq=bl-cat-ind&orientation=landscape',
    count: 268,
  },
  {
    id: 'brand',
    name: '品牌扒皮',
    desc: '拆开品牌叙事的外壳，看营销话术背后真正发生了什么。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20amber%20product%20packaging%20and%20price%20tag%20abstract%20editorial%20flatlay%20on%20cream%20background%20with%20soft%20shadows%2C%20high%20detail&width=800&height=600&seq=bl-cat-brand&orientation=landscape',
    count: 196,
  },
  {
    id: 'society',
    name: '社会观察',
    desc: '记录公共事件里容易被忽略的细节，还原它真实的传播路径。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20amber%20city%20street%20at%20dusk%20abstract%20editorial%20photography%20with%20soft%20golden%20light%20and%20deep%20green%20shadows%2C%20high%20detail&width=800&height=600&seq=bl-cat-soc&orientation=landscape',
    count: 241,
  },
  {
    id: 'culture',
    name: '文化解码',
    desc: '解读流行背后的心理机制与文化土壤，理解我们为何会这样。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20amber%20stacked%20books%20and%20vinyl%20records%20abstract%20editorial%20flatlay%20on%20cream%20background%2C%20moody%20lighting%2C%20high%20detail&width=800&height=600&seq=bl-cat-cul&orientation=landscape',
    count: 269,
  },
];